import React from "react";
import { Text } from "react-native";
import { theme } from "../../theme";
import { styles } from "./Heading.styles";
import { getColorFromVariantKey, } from "@clearabee/ui-library-base";
export const Heading = ({ level = 1, fontSize, styles: userStyles, color, ...rest }) => {
    const colorHex = color ? getColorFromVariantKey(color) : undefined;
    return (React.createElement(Text, { accessibilityRole: "header", "aria-level": level, style: [
            styles.defaults,
            styles[`heading${level}`],
            fontSize && theme.fontDefaults[fontSize],
            userStyles,
            !!colorHex && { color: colorHex },
        ], ...rest }));
};
//# sourceMappingURL=Heading.js.map